import PcaPredict from './PcaPredict'

export default class PcaPredictController {
  constructor () {
    $('.PcaPredict').each((index, element) => new PcaPredict(element))
  }
}
